import React from 'react'
import { HtmlContent } from 'utils'

import styles from './styles/text_component.module.scss'

const TextComponent = ({ title, text }) => {
  return (
    <section className={styles.text_component}>
      {title
        ? <h2 className={styles.text_component__title}>
          {title}
        </h2>
        : null
      }

      <HtmlContent content={text} className={styles.text_component__content} />
    </section>
  )
}

export default TextComponent